import { useEffect } from 'react';

/**
 * active のあいだ、画面（と、それに伴う PC）のスリープを止める（Screen Wake Lock API）。
 *
 * ブラウザ仕様上、タブが非表示になると自動で解除されるため、表示に戻ったときに取り直す。
 * 対応していないブラウザ・取得を拒否された場合は何もしない。
 */
const useWakeLock = (active: boolean): void => {
  useEffect(() => {
    if (!active || typeof navigator === 'undefined' || !('wakeLock' in navigator)) return;

    let sentinel: WakeLockSentinel | null = null;
    let disposed = false;

    const acquire = async () => {
      if (disposed || sentinel || document.visibilityState !== 'visible') return;
      try {
        const lock = await navigator.wakeLock.request('screen');
        if (disposed) {
          lock.release().catch(() => undefined);
          return;
        }
        sentinel = lock;
        lock.addEventListener('release', () => {
          if (sentinel === lock) sentinel = null;
        });
      } catch {
        // 省電力モード等で拒否された
      }
    };

    acquire();
    document.addEventListener('visibilitychange', acquire);
    return () => {
      disposed = true;
      document.removeEventListener('visibilitychange', acquire);
      sentinel?.release().catch(() => undefined);
      sentinel = null;
    };
  }, [active]);
};

export default useWakeLock;
